import script from "./myListDetailPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./myListDetailPage2.vue?vue&type=script&setup=true&lang=js"

import "./myListDetailPage2.vue?vue&type=style&index=0&id=365abb28&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365abb28"]])

export default __exports__